/*
 * @Author: 田鑫
 * @Date: 2021-10-20 13:22:02
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-01-18 10:24:56
 * @Description:
 */

export default [
  {
    name: "opcUserManagement",
    path: "/supplySystem/:supplyId/opcManagement/opcUserManagement",
    meta: { title: "用户列表" },
    component: require("business/supplySystem/opcManagement/opcUserManagement/list.vue")
      .default
  },
  {
    name: "opcInfoManagement",
    path: "/supplySystem/:supplyId/opcManagement/opcInfoManagement",
    meta: { title: "用户预约信息管理" },
    component: require("business/supplySystem/opcManagement/opcInfoManagement/list.vue")
      .default
  },
  {
    name: "hospitalManagement",
    path: "/supplySystem/:supplyId/opcManagement/hospitalManagement",
    meta: { title: "医院管理" },
    component: require("business/supplySystem/opcManagement/hospitalManagement/list.vue")
      .default
  },
  {
    name: "doctorManagement",
    path: "/supplySystem/:supplyId/opcManagement/doctorManagement",
    meta: { title: "专家管理" },
    component: require("business/supplySystem/opcManagement/doctorManagement/list.vue")
      .default
  },
  {
    name: "labelManagement",
    path: "/supplySystem/:supplyId/opcManagement/labelManagement",
    meta: { title: "专家标签管理" },
    component: require("business/supplySystem/opcManagement/labelManagement/list.vue")
      .default
  },
  {
    name: "clinicManagement",
    path: "/supplySystem/:supplyId/opcManagement/clinicManagement",
    meta: { title: "专家就诊管理" },
    component: require("business/supplySystem/opcManagement/clinicManagement/list.vue")
      .default
  },
  {
    name: "inquiryManagement",
    path: "/supplySystem/:supplyId/opcManagement/inquiryManagement",
    meta: { title: "专家问诊管理" },
    component: require("business/supplySystem/opcManagement/inquiryManagement/list.vue")
      .default
  }
];
